<div
	[class]="{'toast': true,'toast--error': status() === statusTypes.error, 'toast--success': status() === statusTypes.success}">
	<button class="toast__close" mat-icon-button (click)="onCloseClick()">
		<ogs-m3-icon icon="xmark" />
	</button>
	<section class="toast__content">
		<ng-content />
	</section>
</div>